<template>
  <Login v-if="!isAuth" />

  <Landing v-else-if="isFirstLogin" />

  <div v-else class="page-wrapper">
    <div class="app-loader" v-if="!ready">
      <div class="app-loader-content">
        <div class="logo">
          <img src="./assets/img/logo_green.png" alt="logo" />
        </div>

        <div class="beta">
          <img src="./assets/img/beta.svg" alt="logo" />
        </div>

        <div class="loader"></div>
      </div>
    </div>

    <Header v-on:toogle-menu="toogleMenu" :isMenuOpen="isMenuOpen" />
    <Error />

    <Menu v-if="isMenuOpen" />
    <ShopList v-else-if="isView('shoplist')" />
    <Contacts v-else-if="isView('contacts')" />
    <Health v-else-if="isView('health')" />
    <Checkup v-else-if="isView('checkup')" />
    <Recommendation v-else-if="isView('recommendations')" />
    <Prescription v-else-if="isView('prescription')" />
    <Questionnaire v-else-if="isView('questionnaire')" />
    <Strategy v-else-if="isView('strategy')" />
    <Conclusion v-else-if="isView('conclusion')" />
    <Schedule v-else />
  </div>
</template>

<script>
  import Menu from './components/Menu';
  import Header from './components/common/Header';
  import Error from './components/common/Error';
  import Schedule from './components/Schedule';
  import Checkup from './components/Checkup';
  import ShopList from './components/ShopList';
  import Landing from './components/Landing';
  import Login from './components/Login';
  import Contacts from './components/Contacts';
  import Health from './components/Health';
  import Recommendation from './components/Recommendation';
  import Prescription from './components/Prescription';
  import Questionnaire from './components/Questionnaire';
  import Strategy from './components/Strategy';
  import Conclusion from './components/Conclusion';
  import {INTERVAL_UPDATE_USER_DATA} from './constants';

  export default {
    components: {
      Menu,
      Header,
      Error,
      Login,
      Landing,
      ShopList,
      Schedule,
      Checkup,
      Contacts,
      Health,
      Recommendation,
      Prescription,
      Questionnaire,
      Strategy,
      Conclusion,
    },

    data() {
      return {
        isMenuOpen: true,
        ready: false,
        questionnaireChecked: false,
      };
    },

    created() {
      this.loadUserData();
    },

    computed: {
      view: function () {
        return this.$store.state.view;
      },

      isAuth: function () {
        return this.$store.getters.hasAuth;
      },

      isFirstLogin: function () {
        return this.$store.getters.isFirstLogin;
      },
    },

    methods: {
      async loadUserData() {
        await this.loadData();

        this.ready = true;

        setInterval(() => {
          this.loadData();
        }, INTERVAL_UPDATE_USER_DATA);
      },

      async checkNewQuestionnaire() {
        if (!this.isAuth) {
          return;
        }

        this.questionnaireChecked = true;

        try {
          await this.$store.dispatch('QUESTIONNAIRE_LOAD_QUESTIONNAIRES');

          const questionnaire = this.$store.getters.getPopoverQuestionnaire;

          if (typeof questionnaire === 'undefined') {
            return;
          }

          await this.$store.dispatch('CHANGE_VIEW', 'questionnaire');
          this.$store.state.questionnaire.questionnaireId = questionnaire.id;
        } catch (e) {
          //do-nothing
        }
      },

      async loadData() {
        if (!this.isAuth) {
          return;
        }

        try {
          await this.$store.dispatch('LOAD_PROFILE');

          await this.checkNewQuestionnaire();

          await this.$store.dispatch('LOAD_PRESCRIPTIONS');
          await this.$store.dispatch('LOAD_CHECKUP_PRESCRIPTIONS');
          await this.$store.dispatch('LOAD_CHECKUP_ANSWERS');
          await this.$store.dispatch('LOAD_TIMES');
          await this.$store.dispatch('LOAD_RECOMMENDATIONS');
        } catch(e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      toogleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
      },

      isView(view) {
        return this.view === view;
      },
    },

    watch: {
      isAuth() {
        window.scrollTo(0, 0);
        this.loadData();
      },

      isFirstLogin() {
        window.scrollTo(0, 0);
      },

      view: function () {
        window.scrollTo(0, 0);
        this.toogleMenu();
      },
    }
  }
</script>

<style lang="scss">
@import "./assets/scss/variables";

.app-loader {
  position: fixed;
  z-index: 11000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #1d4322;

  .app-loader-content {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -50px 0 0 -100px;
    width: 200px;
    height: 100px;

    .logo {
      height: 20px;
      margin: 0 0 5px;
      text-align: center;

      img {
        height: 100%;
      }
    }

    .beta {
      height: 22px;
      margin: 0 0 10px;
      text-align: center;

      img {
        height: 100%;
      }
    }

    .loader {
      border-left: 1px solid #1d4322;
      border-right: 1px solid #1d4322;
    }
  }
}
</style>
